import { mapCandidateResponse } from './helpers'

const mutations = {
  updateQuery: (state, payload) => {
    state.query = payload
  },
  updateCurrPage: (state, payload) => {
    state.currPage = payload
  },
  updateResults: (state, payload) => {
    // console.log({payload})
    payload = payload.map(can => mapCandidateResponse(can))
    state.result = payload
  },
  updateResultCount: (state, payload) => {
    state.resultCount = payload
  },
  setPageCount: (state, payload) => {
    state.pageCount = payload
  },
  setNoResult: (state, payload) => {
    state.noResult = payload
  },
  updateFilters: (state, payload) => {
    state.appliedFilters = payload
  },
  setFavorites: (state, payload) => {
    state.favorites = payload
  },
  setFavoriteCandidates: (state, payload) => {
    state.favoriteCandidates = payload
  },
  setFavoriteCandidatesAndMutate: (state, payload) => {
    payload = payload.map(can =>
      mapCandidateResponse({
        ...can.Candidate[0],
        candidateId: can.candidateId,
        userEmail: can.candidateEmail,
      })
    )
    state.favoriteCandidates = payload
  },
  setRecJobCodes: (state, payload) => {
    state.recJobCodes = payload
  },
  subscriptionDetail: (state, payload) => {
    state.subscriptionDetail = payload
  },
}

export default mutations
